import { lazyLoad } from 'utils/loadable';

export const DownloadPage = lazyLoad(
  () => import('./index'),
  module => module.DownloadPage,
);
